module.exports = __webpack_public_path__ + "img/suggestion.84332888.png";